@if ((errors | async); as errors) {
  @if (errors?.length > 0) {
    @for (alert of errors.slice(0, 2); track alert) {
      <div [ngClass]="alert.pointers?.length ? 'cursor-pointer' : ''"
           (click)="alert.pointers?.length ? openAlertDetails(alert) : null">
        <app-status-alert type="danger" [closeable]="false" cssClass="mb-0">
          <div class="row gx-3">
            <div class="col-auto d-flex align-items-center">
              <i class="fal fa-times-circle text-danger-dark fs-2"></i>
            </div>
            <div class="col d-flex flex-column justify-content-center">
              <div class="fw-medium mb-1">
                {{ alert.header }}
              </div>
              <div class="row gx-1">
                @for (pointer of getPointersWithDescription(alert); track $index; let last = $last) {
                  <div class="col-auto d-flex flex-row">
                    <div>{{ pointer.description }}</div>
                    @if (!last) {
                      <i class="fa fa-light fa-arrow-right ms-1"></i>
                    }
                  </div>
                }
              </div>
            </div>
            @if (alert.pointers?.length) {
              <div class="ms-auto col-auto d-flex flex-row align-items-center text-danger-dark fw-medium">
                <i class="fa fa-fw fa-light fa-chevron-right fs-3"></i>
              </div>
            }
          </div>
        </app-status-alert>
      </div>
    }
  }
}
